export const statusTypes = ["active", "draft"];
